import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drinksMenu", "breakfastMenu", "lunchMenu"]

  connect() {
    this.showMenu('drinks')
  }

  showHide(event) {
    this.showMenu(event.target.id)
  }

  showMenu(menuId) {
    // Set all menus and icons as hidden/inactive
    this.drinksMenuTarget.hidden = true
    this.breakfastMenuTarget.hidden = true
    this.lunchMenuTarget.hidden = true

    this.resetMenuState('drinks')
    this.resetMenuState('breakfast')
    this.resetMenuState('lunch')

    // Show the selected menu and activate its icon
    this[`${menuId}MenuTarget`].hidden = false
    document.getElementById(menuId).classList.add('menu-active')
    document.getElementById(menuId).querySelector('svg').classList.add('image-active')
  }

  resetMenuState(menuId) {
    const menuElement = document.getElementById(menuId)
    menuElement.classList.remove('menu-active')
    menuElement.querySelector('svg').classList.remove('image-active')
  }
}
